<div class="row">
    <!-- Exibe o captcha -->
  <canvas #captchaCanvas class="col-md-3"></canvas>

  <div class="col-md-9">
    <div class="row">
      <div class="col-md-4">
        <input type="text" placeholder="Digite o CAPTCHA" class="form-control"  [(ngModel)]="userInputCaptcha">
      </div>
    </div>
  </div>
  
<!--   <div class="col-md-2">
    <button (click)="reloadCaptcha()" type="button" class="btn btn-primary">
      <i class="fa fa-refresh" aria-hidden="true"></i>
    </button>
  </div> -->
</div>
